import Vue from 'vue';
import { scaleLinear } from 'd3';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    props: {
        /** The currently selected value in the dropdown */
        selectedValue: { type: [String, Number], default: '' },
        /** The data suggestion for the dropdown item;
              {
                'name': 'prices',
                'frequency': 100,
                'similarity': 0.678
              }
        */
        suggestion: { type: Object, default: () => ({}) },
        /** The total number of frames in the dataset to use as a denominator **/
        numFrames: { type: Number, default: undefined },
        /** Default item truncation length (number of characters) */
        truncationLength: { type: Number, default: 40 },
        /** Is this suggestion toggled? */
        toggled: { type: Boolean, default: false }
    },
    data() {
        return {
            colourGradient: scaleLinear()
                .domain([0.2, 0.8]) // practical (as opposed to theoretical) similarity range
                .range([
                '#aaaaaa',
                '#21ba45' // <= the darkest shade we want
            ])
        };
    },
    methods: {
        decimalAsPercent: FormatUtils.decimalAsPercent,
        onClick(e) {
            if (e.ctrlKey || e.metaKey) {
                this.$emit('ctrl-click', this.suggestion);
            }
            else {
                this.$emit('click', this.suggestion);
            }
        }
    }
});
